import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Spinner from "../components/common/Spinner";
import useAuth from "../Hooks/useAuth";
// import { useServices, useServicesById } from "../Hooks/useServices";
import ServiceCards from "../sections/Service/ServiceCards";
import { useSelector } from "react-redux";
import Filters from "../sections/Service/Filters";
import MainButton from "../components/common/MainButton/MainButton";
import Login from "../sections/Login/Login";
import { SignUp as SignUpRegister } from "../sections/SignUp/SignUp";
import { GetPostsByCategory } from "../services/PostService";
import { useGraphQL } from "../context/GraphQLProvider";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_CATEGORY_FILTER_GAP_CLASS,
  PUBLIC_CONTENT_TO_CTA_CLASS,
  PUBLIC_CARD_GRID_GAP_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";

const Services = ({ formik }) => {
  const LISTING_TYPE = "Feature";
  const { auth } = useAuth();
  const location = useLocation();
  const { slug } = useParams();
  // const { status, data } = useServices();
  // const { status: AuthnicateStatus, data: AuthnicateData } = useServicesById(
  //   auth?.user?.id
  // );
  const graphqlService = useGraphQL();
  const [categoryPosts, setCategoryPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [FeaturedServices, setFeaturedServices] = useState([]);
  const [PopulorServices, setPopulorServices] = useState([]);
  const [RecentServices, setRecentServices] = useState([]);
  const [SignUp, setSignUp] = React.useState(false);
  const [SignIn, setSignIn] = React.useState(false);
  
  // Add state for posts pagination
  const [visiblePostsCount, setVisiblePostsCount] = useState(32);
  const [allPosts, setAllPosts] = useState([]);
  
  // const services = !auth?.user
  //   ? data?.data.key.$values ?? []
  //   : AuthnicateData?.data?.$values ?? [];

  const fetchPostsByCategory = async () => {
    if (slug) {
      setIsLoading(true);
      try {
        const response = await GetPostsByCategory(graphqlService, {
          filters: {
            mainCategory: slug === "plumbing" ? "13" : "0"
          }
        });
        setCategoryPosts(response?.getPostsByCategory?.posts || []);
      } catch (error) {
        console.error("Error fetching category posts:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchPostsByCategory();
  }, [slug]);

  // useEffect(() => {
    // const filterFeatured = services?.filter(
    //   (list) => list?.listType === LISTING_TYPE
    // );
    
    // Combine all posts for pagination
    // const combinedPosts = [
    //   ...sortOrderByDescbyRating(filterFeatured),
    //   ...sortOrderByDescbyRating(services),
    //   ...sortOrderByDescbyRating(services)
    // ];
    
    // Remove duplicates based on id
    // const uniquePosts = combinedPosts.filter((post, index, self) =>
    //   index === self.findIndex(p => p.id === post.id)
    // );
    
    // setAllPosts(uniquePosts);
    
    // if (!auth?.user) {
      // For non-logged-in users, show limited posts (5 each)
    //   setFeaturedServices(sortOrderByDescbyRating(filterFeatured.slice(0, 5)));
    //   setPopulorServices(sortOrderByDescbyRating(services.slice(0, 5)));
    //   setRecentServices(sortOrderByDescbyRating(services.slice(0, 5)));
    // } else {
      // For logged-in users, show posts based on visiblePostsCount
    //   const featuredSlice = Math.min(Math.ceil(visiblePostsCount * 0.4), filterFeatured.length);
    //   const popularSlice = Math.min(Math.ceil(visiblePostsCount * 0.3), services.length);
    //   const recentSlice = Math.min(Math.ceil(visiblePostsCount * 0.3), services.length);
      
    //   setFeaturedServices(sortOrderByDescbyRating(filterFeatured.slice(0, featuredSlice)));
    //   setPopulorServices(sortOrderByDescbyRating(services.slice(0, popularSlice)));
    //   setRecentServices(sortOrderByDescbyRating(services.slice(0, recentSlice)));
    // }
  // }, [slug, AuthnicateData, location, visiblePostsCount]);

  // const sortOrderByDescbyRating = (List) => {
  //   let sortedDsc = List.sort((a, b) => {
  //     return parseInt(b?.listRating) - parseInt(a?.listRating);
  //   });
  //   return sortedDsc;
  // };

  const loadMorePosts = () => {
    setVisiblePostsCount(prevCount => prevCount + 12);
  };

  // Calculate total visible posts
  const totalVisiblePosts = FeaturedServices.length + PopulorServices.length + RecentServices.length;
  const hasMorePosts = totalVisiblePosts < allPosts.length;

  const businessCategories = useSelector(
    (category) => category.BusinessCategoryReducer
  );

  return (
    <>
      <div className={`tp-container-fluid ${publicMainHeaderOffsetClass()}`}>
        {(isLoading) && (
          <Spinner />
        )}
        <Filters />
      </div>
      {!isLoading && (
        <>
          <div className={PUBLIC_CATEGORY_FILTER_GAP_CLASS}>
            <div className="flex justify-center">
              <div
                className={`tp-container-fluid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 ${PUBLIC_CARD_GRID_GAP_CLASS}`}
              >
                {slug ? (
                  <ServiceCards
                    addType={"Category Posts"}
                    Services={categoryPosts}
                  />
                ) : (
                  <>
                    <ServiceCards
                      addType={"Featured"}
                      Services={FeaturedServices}
                    />
                    <ServiceCards addType={"Popular"} Services={PopulorServices} />
                    <ServiceCards addType={"Recent"} Services={RecentServices} />
                  </>
                )}
              </div>
            </div>
            {SignIn ? (
              <Login
                SignIn={SignIn}
                setSignIn={setSignIn}
                SignUpState={SignUp}
                setSignUpState={setSignUp}
              />
            ) : (
              ""
            )}
            {SignUp ? (
              <SignUpRegister
                SignUpState={SignUp}
                setSignUpState={setSignUp}
                SignIn={SignIn}
                setSignIn={setSignIn}
              />
            ) : (
              ""
            )}

            {auth?.user ? (
              // Show "Load 12 More" button for logged-in users
              hasMorePosts && (
                <div
                  className={`flex items-center justify-center ${PUBLIC_CONTENT_TO_CTA_CLASS}`}
                >
                  <MainButton
                    variant={"large"}
                    onClick={loadMorePosts}
                  >
                    Load 12 More
                  </MainButton>
                </div>
              )
            ) : (
              // Show "Sign up to continue" button for non-logged-in users
              <div
                className={`flex items-center justify-center ${PUBLIC_CONTENT_TO_CTA_CLASS}`}
              >
                <MainButton
                  variant={"large"}
                  onClick={() => setSignUp(true)}
                >
                  Sign up to continue
                </MainButton>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Services;
